<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open -extra-width">

  <div class="esf-main-sidebar__content">
    <ng-container [ngSwitch]="selectedInvoice.type">
      <h4 *ngSwitchCase="'Invoice'" class="esf-heading--sub-section" style="margin-bottom: 0.2em;">{{ selectedInvoice.translatedType }} {{ selectedInvoice.orderDetails.displayInvoiceNumber }}</h4>
      <h4 *ngSwitchCase="'Reservation'" class="esf-heading--sub-section" style="margin-bottom: 0.2em;">{{ selectedInvoice.translatedType }} {{ selectedInvoice.reservationDetails.reservationId }}</h4>
      <h4 *ngSwitchCase="'Cancellation'" class="esf-heading--sub-section" style="margin-bottom: 0.2em;">{{ selectedInvoice.translatedType }} {{ selectedInvoice.orderDetails.displayInvoiceNumber }}</h4>
    </ng-container>

    <p class="esf-ticket__info-text" style="margin-bottom: 0.2em;">
      <span i18n='Text@@invoiceComponent.text.created'>Created</span>
      <span>: {{ selectedInvoice.orderDetails.invoiceDate.date | date:selectedInvoice.orderDetails.invoiceDate.format }}</span>
    </p>

    <p *ngIf="selectedInvoice.type === 'Reservation'" class="esf-ticket__info-text" style="margin-bottom: 0.2em;">
      <span i18n='Text@@invoiceComponent.text.validUntill'>Valid untill: </span>
      <span>{{ selectedInvoice.reservationDetails.expiryDate.date | date:selectedInvoice.reservationDetails.expiryDate.format }}</span>
    </p>

    <div class="esf-accordion esf-accordion--info-tiles" style="padding-top: 20px;">
      <ng-container *ngIf="!selectedClub.isDataFeedActive">
        <div class="esf-accordion__unit address" *ngIf="selectedInvoice?.standardAddress && selectedInvoice?.deliveryAddress">
          <div class="esf-accordion__trigger" [ngClass]="{'-is-open': addressDataOpened}" (click)="toggleSection('address')">
            <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
              <span class="esf-action-heading__text" i18n='Section title@@invoiceComponent.heading.addressData'>Address data</span>
            </h4>
          </div>
          <div class="esf-accordion__target" [ngClass]="{'no-display': !addressDataOpened}">

            <div class="esf-info-tile esf-info-tile--static esf-info-tile--event" *ngIf="selectedInvoice.deliveryAddress && selectedInvoice.standardAddress">
              <div class="esf-info-tile__content">
                <div class="esf-ticket">
                  <div class="esf-ticket__info">
                    <span class="esf-ticket__info-item esf-ticket__stand">
                      <span class="esf-ticket__info-label" i18n='Text@@invoiceComponent.text.billingAddress'>Billing address</span>
                      <span class="esf-ticket__info-text">
                        {{ selectedInvoice.standardAddress.firstName }} {{ selectedInvoice.standardAddress.lastName }}<br>
                        {{ selectedInvoice.standardAddress.street }}<br>
                        {{ selectedInvoice.standardAddress.postalCode }} {{ selectedInvoice.standardAddress.city }}, {{ selectedInvoice.standardAddress.country }}
                      </span>
                    </span>
                    <span class="esf-ticket__info-item esf-ticket__block"></span>
                    <span class="esf-ticket__info-item esf-ticket__stand" *ngIf="!isReservation">
                      <span class="esf-ticket__info-label" i18n='Text@@invoiceComponent.text.shippingAddress'>Shipping address</span>

                      <span [ngSwitch]="isAddressEqual">
                        <span class="esf-ticket__info-text" style="opacity: 0.5;" *ngSwitchCase="true" i18n="@@invoiceComponent.text.equalToBillingAddress">
                          Equal to billing address
                        </span>
                        <span class="esf-ticket__info-text" *ngSwitchCase="false">
                          {{ selectedInvoice.deliveryAddress.firstName }} {{ selectedInvoice.deliveryAddress.lastName }}<br>
                          {{ selectedInvoice.deliveryAddress.street }}<br>
                          {{ selectedInvoice.deliveryAddress.postalCode }} {{ selectedInvoice.deliveryAddress.city }}, {{ selectedInvoice.deliveryAddress.country }}
                        </span>
                      </span>

                    </span>
                  </div>
                  <!-- <div class="esf-ticket__data">
                    <span class="esf-ticket__data-item esf-ticket__number">
                      <span class="esf-tooltip esf-tooltip--top" i18n-data-tooltip='Tooltip@@general.tooltip.shippedOn' data-tooltip="Shipped on">
                        {{ selectedInvoice.orderDetails.shippingDate | date:'dd.MM.yyyy' }}
                      </span>
                    </span>
                    <span class="esf-ticket__data-item esf-ticket__status">
                      <span class="esf-tag" [ngClass]="getInvoiceOrderStatusCss(invoice.status)">{{ invoiceOrderStatus.getTranslatedInvoiceOrderStatus(invoice.status) }}</span>
                    </span>
                  </div> -->
                </div>
              </div>
            </div>

          </div>
        </div>
      </ng-container>

      <div class="esf-accordion__unit payment-and-shipment" *ngIf="selectedInvoice.type !== 'Reservation'">
        <div class="esf-accordion__trigger" [ngClass]="{'-is-open': paymentAndShipmentOpened}" (click)="toggleSection('paymentAndShipment')">
          <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
            <span class="esf-action-heading__text" i18n='Section title@@invoiceComponent.heading.paymentAndShipment'>Payment and shipment</span>
          </h4>
        </div>
        <div class="esf-accordion__target" [ngClass]="{'no-display': !paymentAndShipmentOpened}">

          <div class="esf-info-tile esf-info-tile--static esf-info-tile--event">
            <div class="esf-info-tile__content">
              <div class="esf-ticket">
                <div class="esf-ticket__info">
                  <span class="esf-ticket__info-item esf-ticket__stand">
                    <span class="esf-ticket__info-label" i18n='Text@@invoiceComponent.text.payment'>Payment</span>
                    <span class="esf-ticket__info-text">
                      {{ selectedInvoice.orderDetails.translatedPaymentType }}<br>
                      {{ selectedInvoice.orderDetails.paymentDetails.value | currency:selectedInvoice.orderDetails.paymentDetails.currency:'code':undefined:locale }}
                    </span>
                  </span>
                  <span class="esf-ticket__info-item esf-ticket__block"></span>
                  <span class="esf-ticket__info-item esf-ticket__stand">
                    <span class="esf-ticket__info-label" i18n='Text@@invoiceComponent.text.shipping'>Shipping</span>

                    <span [ngSwitch]="selectedInvoice.orderDetails.translatedShippingType" class="esf-ticket__info-text">

                      <span *ngSwitchDefault>
                        {{ selectedInvoice.orderDetails.translatedShippingType }}<br>
                        <span [ngSwitch]="selectedInvoice.orderDetails.shippingDetails.value">
                          <span *ngSwitchCase="0" i18n="@@general.status.noShippingFee">
                            No shipping fee
                          </span>
                          <span *ngSwitchDefault>
                            {{ selectedInvoice.orderDetails.shippingDetails.value | currency:selectedInvoice.orderDetails.shippingDetails.currency:'code':undefined:locale }}
                          </span>
                        </span>
                      </span>

                      <span *ngSwitchCase="null" i18n="@@general.status.noShipping">
                        No shipping
                      </span>

                    </span>

                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="esf-accordion__unit booking-details">
        <div class="esf-accordion__trigger" [ngClass]="{'-is-open': bookingDetailOpened}" (click)="toggleSection('bookingDetails')">
          <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
            <span class="esf-action-heading__text" i18n='Section title@@invoiceComponent.heading.bookingDetails'>Booking details</span>
          </h4>
        </div>
        <div class="esf-accordion__target" [ngClass]="{'no-display': !bookingDetailOpened}">

          <div class="esf-info-tile esf-info-tile--static esf-info-tile--event">
            <div class="esf-info-tile__content">
              <div class="esf-ticket">
                <div class="esf-ticket__info">
                  <span class="esf-ticket__info-item esf-ticket__stand">
                    <span class="esf-ticket__info-label" i18n='Text@@invoiceComponent.text.affiliate'>Affiliate</span>
                    <span class="esf-ticket__info-text">
                      {{ selectedInvoice.affiliate.title }}
                    </span>
                  </span>
                  <span class="esf-ticket__info-item esf-ticket__block"></span>
                  <span class="esf-ticket__info-item esf-ticket__stand">
                    <span class="esf-ticket__info-label" i18n='Text@@invoiceComponent.text.operator'>Operator</span>
                    <span class="esf-ticket__info-text">
                      {{ selectedInvoice.saleOperator.name }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="esf-accordion__unit tickets">
        <div class="esf-accordion__trigger" [ngClass]="{'-is-open': ticketsOpened}" (click)="toggleSection('tickets')">
          <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
            <span class="esf-action-heading__text" i18n='Section title@@invoiceComponent.heading.tickets'>Tickets</span>
          </h4>
        </div>
        <div class="esf-accordion__target" [ngClass]="{'no-display': !ticketsOpened}">

          <ng-container *ngFor="let event of selectedInvoice?.events">
            <div class="esf-info-tile esf-info-tile--static esf-info-tile--event">
              <div class="esf-info-tile__content">
                <div class="esf-event-info">
                  <h5 class="esf-heading esf-heading--data esf-event-info__heading">
                    <ng-container [ngSwitch]="selectedClub.isDataFeedActive">
                      <ng-container *ngSwitchCase="false">
                        <span class="esf-event-info-item esf-event-info__host">{{ event.eventDetails.competitionName }}</span>
                        <span class="esf-event-info-item esf-event-info__type-2">{{ event.eventDetails.name }}</span>
                      </ng-container>

                      <ng-container *ngSwitchCase="true">
                        <span class="esf-event-info-item esf-event-info__type-2">{{ event.eventDetails.competitionName }}</span>
                      </ng-container>
                    </ng-container>
                  </h5>
                  <h3 class="esf-heading esf-heading--sub-section esf-event-info__title">
                    <!-- <span class="esf-event-info__home">ALBA Berlin</span> -->
                    <span class="esf-event-info__guest">{{ event.eventDetails.getFormattedPerformers() }}</span>
                  </h3>
                  <div class="esf-event-info__data">
                    <span class="esf-event-info__data-item esf-event-info__date-and-time">{{ event.eventDetails.dateDetails.date | date:event.eventDetails.dateDetails.format }}</span>
                    <span class="esf-event-info__data-item esf-event-info__venue">{{ event.eventDetails.location }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="esf-info-tile esf-info-tile--static esf-info-tile--event" *ngFor="let ticket of event.tickets">
              <div class="esf-info-tile__content">
                <div class="esf-ticket">
                  <div class="esf-ticket__info">
                    <!-- <span class="esf-ticket__info-item esf-ticket__stand">
                      <span class="esf-ticket__info-label" i18n='Text@@invoiceComponent.text.stand'>Stand</span>
                      <span class="esf-ticket__info-text">{{ ticket.tribune }}</span>
                    </span> -->
                    <span class="esf-ticket__info-item esf-ticket__block">
                      <span class="esf-ticket__info-label" i18n='Text@@invoiceComponent.text.block'>Block</span>
                      <span class="esf-ticket__info-text">{{ ticket.blockName }}</span>
                    </span>
                    <span class="esf-ticket__info-item esf-ticket__row">
                      <span class="esf-ticket__info-label" i18n='Text@@invoiceComponent.text.row'>Row</span>
                      <span class="esf-ticket__info-text">{{ ticket.row }}</span>
                    </span>
                    <span class="esf-ticket__info-item esf-ticket__seat">
                      <span class="esf-ticket__info-label" i18n='Text@@invoiceComponent.text.seat'>Seat</span>
                      <span class="esf-ticket__info-text">{{ ticket.seat }}</span>
                    </span>
                  </div>
                  <div class="esf-ticket__price">
                    <span class="esf-ticket__price-item esf-ticket__price-category">
                      {{ ticket.displayType }}
                    </span>
                    <span class="esf-ticket__price-item esf-ticket__price-tag">
                      {{ ticket.price | currency:selectedInvoice.orderDetails.paymentDetails.currency:'code':undefined:locale }}
                    </span>
                  </div>
                  <div [ngClass]="{'esf-ticket__price': ticket.ticketAccesses?.length, 'esf-ticket__data': !ticket.ticketAccesses?.length}" class="esf-ticket__price">
                    <span class="esf-ticket__data-item esf-ticket__number">{{ ticket.ticketId }}</span>
                    <span class="esf-ticket__data-item esf-ticket__status">
                      <button class="esf-button esf-button--simple ticket-access-icon" [edsTooltip]="tooltipTranslations.i18nCheckedIn" *ngIf="ticket.ticketAccesses?.length">
                        <svg class="esf-icon esf-button__icon" width="16" height="16">
                          <use xlink:href="#esf-icon-door-enter-16"></use>
                        </svg>
                        <span class="esf-button__icon-text"></span>
                      </button>
                      <span class="esf-tag" [ngClass]="invoiceOrderStatus.getStatusCssClass(ticket.status)">{{ invoiceOrderStatus.getTranslatedInvoiceStatus(ticket.status) }}</span>
                    </span>
                  </div>

                  <ng-container *ngIf="ticket.ticketAccesses?.length">
                    <div class="esf-ticket__info" style="border-bottom: none;">
                      <span class="esf-ticket__info-item esf-ticket__block">
                        <span class="esf-ticket__info-label" i18n='Text@@invoiceComponent.text.timestamp'>Timestamp</span>
                        <ng-container *ngFor="let ticketAccess of ticket.ticketAccesses">
                          <span class="esf-ticket__info-text">{{ ticketAccess.scannedAt.date | date: ticketAccess.scannedAt.format}}</span>
                        </ng-container>
                      </span>
                      <span class="esf-ticket__info-item esf-ticket__row" style="flex-basis: inherit">
                        <span class="esf-ticket__info-label" i18n='Text@@invoiceComponent.text.admission'>Admission</span>
                        <ng-container *ngFor="let ticketAccess of ticket.ticketAccesses">
                          <span class="esf-ticket__info-text" [edsTooltip]="ticketAccess.checkpoint">{{ ticketAccess.area }} </span>
                        </ng-container>
                      </span>
                    </div>
                  </ng-container>

                </div>
              </div>
            </div>
          </ng-container>

        </div>
      </div>
    </div>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open -extra-width">
  <ng-container [ngSwitch]="selectedInvoice?.type">
    <app-submit-row-buttons *ngSwitchCase="'Reservation'"
                            [form]="'updateCommunicationForm'"
                            [isFieldValid]="customer.canAccessTixx"
                            [cancelButtonText]="buttonsTranslations.i18nBack"
                            [submitButtonText]="buttonsTranslations.i18nToTixx"
                            (submitButton)="tixxConnectionService.initiateTixxConnection(customer, selectedInvoice.reservationDetails.reservationId)"
                            (cancelButton)="customerService.toggleAllModal(false)">
    </app-submit-row-buttons>
    <app-submit-row-buttons *ngSwitchDefault
                            [isFieldValid]="false"
                            [form]="'updateCommunicationForm'"
                            [cancelButtonText]="buttonsTranslations.i18nBack"
                            [showSubmit]="false"
                            (cancelButton)="customerService.toggleAllModal(false)">
    </app-submit-row-buttons>
  </ng-container>
</div>

<div class="esf-hamburger esf-hamburger--working-space esf-js-workingSpaceToggle -has-transition -is-open"
     (click)="customerService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
